import PropTypes from 'prop-types';
import { Sector } from 'recharts';

const RenderActiveShape = props => {
    const {
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        COLORS,
        activeIndex,
    } = props;
    return (
        <g>
            <text
                x={cx}
                y={cy}
                dy={-35}
                fontSize="78px"
                fill={COLORS[activeIndex]}
                textAnchor="middle"
                fontWeight="700"
            >
                {payload.value}
            </text>
            <text x={cx} y={cy} dy={-15} textAnchor="middle" fill="#6C727F">
                {payload.name}
            </text>

            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
        </g>
    );
};

RenderActiveShape.propTypes = {
    cx: PropTypes.number,
    cy: PropTypes.number,
    innerRadius: PropTypes.number,
    outerRadius: PropTypes.number,
    startAngle: PropTypes.number,
    endAngle: PropTypes.number,
    fill: PropTypes.string,
    COLORS: PropTypes.any,
    activeIndex: PropTypes.any,
    payload: PropTypes.object,
};

export default RenderActiveShape;
